// extracted by mini-css-extract-plugin
module.exports = {"gif":"section-bluegold-module--gif--2n4hF"};